const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/team-chat.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/team-chat')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// ─── Types ────────────────────────────────────────────────────────────────────

interface Channel {
  id: string;
  name: string;
  type: 'general' | 'announcements' | 'custom';
  unreadCount: number;
}
interface Message {
  id: string;
  channelId: string;
  senderId: string;
  senderName: string;
  senderAvatar?: string;
  content: string;
  timestamp: string;
  isPinned: boolean;
  replyTo?: {
    id: string;
    senderName: string;
    content: string;
  };
  isSystem?: boolean;
}

// ─── Component ────────────────────────────────────────────────────────────────